<template>
  <div class="app-container">
    <list ref="list" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button
          size="mini"
          type="primary"
          @click="create"
          icon="el-icon-plus"
          >添加</el-button
        >
        <el-button size="mini" type="success" plain @click="onExport" >导出</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="test_print"
          :disabled="checkList.length === 0"
          >打印测试</el-button
        >
        <!-- <el-button
          size="mini"
          class="filter-item"
          type="danger"
          @click="delRows"
          >删除</el-button
        > -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" v-if="row.Status==2" @click="detailsById(row.DocId)">查看</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
      <div class="list-head" style="margin-top: 10px;">
      <span>单据信息</span>
    </div>
    <el-table  @selection-change="handleSelectionChange"  class="tb-c-head" :data="Details" v-loading="isLoading" border  show-summary  :summary-method="getSummaries">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="条码"   show-overflow-tooltip />
      <el-table-column label="商品名称" prop="GoodsName"/>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="MainUnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量">
        <template slot-scope="{ row }">
          <span>{{row.Quantity}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="Price" label="单价" /> -->
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">
          <span >{{row.Price}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="CostPrice" label="成本" />
      <el-table-column prop="WarehouseName" label="仓库" />
      <el-table-column prop="CostPrice" label="成本" />
      <el-table-column prop="Amount" label="金额" />
      <el-table-column prop="AvailableQuantity" label="可用量" />
      <el-table-column prop="Remark" label="备注" />
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
    <print-dialog ref="printDialog"  :columns="columns" :data="columnData" :form-data="formData" img-url="http://124.71.106.123:1031"></print-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/stock/bismanage/out/list";
import editDialog from "@/components/stock/bismanage/out/editDialog";
import detailsDialog from "@/components/stock/bismanage/out/detailsDialog";
import printDialog from '@/components/common/printDialog'

export default {
  name: "comment",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog,
    printDialog
  },
  data() {
    return {
      api: require("@/api/stock/outDoc").default,
      Details: [],
      isLoading: false,
      columns: [
        {
          label: '单据编号',
          data: {
            key: 'DocNo',
            label: '单据编号',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '单据日期',
          data: {
            key: 'DocDate',
            label: '单据日期',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '仓库',
          data: {
            key: 'WarehouseName',
            label: '仓库',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '商品种类',
          data: {
            key: 'GoodsNames',
            label: '商品种类',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '单据状态',
          data: {
            key: 'Status',
            label: '单据状态',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '条码',
          data: {
            key: 'BarCode',
            label: '条码',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '商品名称',
          data: {
            key: 'GoodsName',
            label: '商品名称',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '规格型号',
          data: {
            key: 'Model',
            label: '规格型号',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '单位',
          data: {
            key: 'UnitName',
            label: '单位',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '数量',
          data: {
            key: 'Quantity',
            label: '数量',
            isSum: true,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '单价',
          data: {
            key: 'Price',
            label: '单价',
            isSum: true,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '成本价',
          data: {
            key: 'CostPrice',
            label: '成本价',
            isSum: true,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '金额',
          data: {
            key: 'Amount',
            label: '金额',
            isSum: true,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
        {
          label: '可用量',
          data: {
            key: 'AvailableQuantity',
            label: '可用量',
            isSum: true,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: "normal",
              fontFamily: "宋体",
            }
          }
        },
      ],
      columnData: [],
      formData: [],
      currentObj: {},
      checkList: [],
    }
  },
  methods: {
    test_print(){
      let data = this.$refs.list.getPrintData();
      this.formData = data;
      let arr = [];
      this.checkList.forEach(item => {
        let {BarCode, GoodsName, Model, UnitName, Quantity, Price, CostPrice, Amount, AvailableQuantity} = item;
        let o = {
          BarCode, GoodsName, Model, UnitName, Quantity,Price, CostPrice, Amount, AvailableQuantity,
          ...this.currentObj
        };
        arr.push(o)
      })
      this.columnData = arr;

      console.log('columns', this.columns,'columnData',this.columnData)

      this.$refs.printDialog.open();
    },
    handleSelectionChange(list){
      this.checkList = list;
    },
    reload() {
      this.$refs.list.reload();
      this.Details = [];
    },
    onChange(row) {
      
      console.log('row', row);
      let {DocNo, DocDate, WarehouseName, GoodsNames, Status} = row;
      if(Status === 0){
        Status = '草稿'
      }else if(Status === 1){
         Status = '未生效'
      }else if(Status === 2){
          Status = '已生效'
      }
      let o = {
        DocNo, DocDate, WarehouseName, GoodsNames, Status
      }
      this.currentObj = o;

      this.Details = [];
      this.isLoading = true;
      this.api.info(row.DocId).then((res) => {
        this.isLoading = false;
        if (res.Data) {
          this.Details = res.Data.Goods;

        }
      });
    },
       getSummaries(param) {
      
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 5 || index === 7) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor( (prev + curr)*100 )/100;
              } else {
                return Math.floor(prev*100)/100;
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    check(row) {
      sessionStorage.setItem('check','1')
      this.$refs.detailsDialog.openEditById(row.DocId);
    },
    detailsById(id){
        this.$refs.detailsDialog.openDetailsById(id);
    },
    delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete(id).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>